const section = document.querySelectorAll('.section');
const inBackend = document.body.classList.contains('neos-backend');

function isInView(element) {    
    [...element].forEach(function(el, index, elArray) {
        const rect = el.getBoundingClientRect(); 
        let  offset= rect.height -500;
        
        if (rect.top >= 0 && rect.bottom - offset <= (window.innerHeight || document.documentElement.clientHeight)) {
            changeNavItemState(el.firstElementChild.id); 
            navigateSections(index, elArray);
            return;           
        }
    });
}

function navigateSections(index, navItem) {
    if(!inBackend) {
        document.addEventListener('keydown', (e) => {
            if ((e.code == 'ArrowUp' || e.code == 'ArrowLeft' || e.code == 'KeyW' || e.code == 'KeyA') && index != 0 ) {
                e.preventDefault();
                changeNavItemState(navItem[index-1])
                scrollToAnchor(navItem[index-1])
            } else if ((e.code == 'ArrowDown' || e.code == 'ArrowRight' || e.code == 'KeyS' || e.code == 'KeyD') && index < navItem.length) {
                e.preventDefault();
                changeNavItemState(navItem[index+1])
                scrollToAnchor(navItem[index+1])
            }
        });
    }    
}

function scrollToAnchor(nextSection) {
    if(nextSection) {
        changeNavItemState(nextSection);
        nextSection.scrollIntoView()
    }
}

function changeNavItemState(item) {
    const links = document.querySelectorAll('.main-nav__link--level-1');

    [...links].forEach((link) => {     
        link.parentElement.classList.remove('main-nav__item--active')       
        if (link.getAttribute('href') == '#'+item) {
            link.parentElement.classList.add('main-nav__item--active')
        }
    }); 
}

if (section) {
    window.addEventListener('load', () => {
        const ctaScroll = document.querySelector('.header-image__cta');

        if(ctaScroll) {
            ctaScroll.addEventListener('click', (e) => {
                changeNavItemState(section[0])
                scrollToAnchor(section[0])
            })
        }

        window.addEventListener('keydown', () => {
            navigateSections(-1, section)
        })
    })

    isInView(section);

    ['scroll','keydown', 'click'].forEach( e => 
        window.addEventListener(e, () => {
            isInView(section);
        })
    );
}
